export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ASSOCIADO = 'ASSOCIADO',
  SECRETARIA = 'SECRETARIA',
  SUPERVISOR = 'SUPERVISOR',
  RELACIONADOR = 'RELACIONADOR',
  LIDER_VENDAS = 'LIDER_VENDAS',
  USER = 'USER'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export interface ILoginCredentials {
  username: string; // Nome de usuário para login (substitui email)
  password: string;
}

export interface IRegisterData extends ILoginCredentials {
  email: string; // Email ainda necessário para cadastro
  firstName: string;
  lastName: string;
  /** Empresa à qual o usuário solicita vínculo no auto-cadastro */
  tenantId?: string | number;
  tenant_id?: number;
  role?: UserRole;
}

export interface IAuthUser {
  id: number;
  uuid?: string; // UUID original para Supabase
  email: string;
  username: string; // Nome de usuário único para login
  first_name: string;
  last_name: string;
  role: UserRole;
  status: UserStatus;
  tenant_id: number | null;
  tenant?: {
    id: number;
    nome: string;
  } | null;
  avatar?: string; // URL do avatar do usuário
}

export interface IAuthError {
  message: string;
  code: string;
}

export interface IAuthState {
  user: IAuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: IAuthError | null;
}

export interface IAuthResponse {
  status?: 'SUCCESS' | 'PENDING' | 'REJECTED' | 'NOT_FOUND' | 'UNAUTHORIZED' | 'ERROR' | 'NO_USERS';
  message?: string;
  access_token?: string;
  refresh_token?: string;
  user?: IAuthUser;
}

export interface IAuthContext {
  user: IAuthUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (credentials: ILoginCredentials) => Promise<IAuthResponse>;
  register: (data: IRegisterData) => Promise<IAuthResponse>;
  logout: () => void;
}

export interface IRefreshTokenResponse {
  access_token: string;
  refresh_token: string;
}

export interface IPasswordReset {
  username: string; // Nome de usuário para recuperação de senha
}

export interface IFirstUserResponse {
  exists: boolean;
} 